import { Component, Optional } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'app-dialog-proficiency',
    templateUrl: 'dialog-proficiency.component.html',
    styleUrls: ['./dialog-proficiency.component.css'],
    standalone: false
})

  export class DialogProficiencyComponent {
    constructor(@Optional() public dialogRef: MatDialogRef<DialogProficiencyComponent>) {}

  closeDialog() {
    this.dialogRef.close();
  }
}
